// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__14Ie4","location":"Header_location__2Zze_"};